import client from './client';
export { default as QueryComponent } from './util/QueryComponent';

export default client;
